<nav id="navbarMobile" class="navbar fixed-top navbar-expand-lg ">
    <div class="header-logo">
        <img class="logo-img" src="../../../assets/images/logo.svg">
    </div>
    <button style="margin-right:10px" class="navbar-toggler" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon" style="height:40px"></span>
    </button>
</nav>
